﻿/* eslint-disable @typescript-eslint/ban-types */
export class WatcherComponent<T> {
    private readonly _onGetWatchers: Function[];

    private readonly _onSetWatchers: Function[];

    private _value: T;

    get value(): T {
        for (let i = 0; i < this._onGetWatchers.length; i++) {
            this._onGetWatchers[i]();
        }

        return this._value;
    }

    set value(newValue: T) {
        this._value = newValue;

        for (let i = 0; i < this._onSetWatchers.length; i++) {
            this._onSetWatchers[i]();
        }
    }

    constructor() {
        this._onGetWatchers = [];
        this._onSetWatchers = [];
    }

    addOnGetWatcher = (watcher: Function): void => {
        this._onGetWatchers.push(watcher);
    };

    addOnSetWatcher = (watcher: Function): void => {
        this._onSetWatchers.push(watcher);
    };

    triggerWatchers = (): void => {
        for (let i = 0; i < this._onGetWatchers.length; i++) {
            this._onGetWatchers[i]();
        }

        for (let i = 0; i < this._onSetWatchers.length; i++) {
            this._onSetWatchers[i]();
        }
    };
}
/* eslint-enable @typescript-eslint/ban-types */
